export var updateWixCounters = function (siteStore, productId, uuid) {
    var query = {
        method: 'post',
        headers: { 'Content-Type': 'application/json', Accept: '*/*' },
        body: JSON.stringify({
            messageId: uuid,
            metrics: [
                {
                    type: 'product',
                    reportMetrics: [{ name: 'view', value: 1 }],
                    properties: { store_id: siteStore.storeId, product_id: productId },
                },
            ],
        }),
    };
    // tslint:disable-next-line:no-floating-promises
    fetch("https://stores-counters.wix.com/collector/rest/collect-js", query);
};
//# sourceMappingURL=countersApi.js.map